import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  pollResultByGroupIdHandler,
  pollResultHandler,
} from "../../../../store/actions/actionHandlers/socialActionHandler";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import classes from "./PollResult.module.scss";
import Input from "../../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage, injectIntl } from "react-intl";

const PollResult = ({intl}) => {
  const dispatch = useDispatch();
  const [pollUsageData, setpollUsageData] = useState({});
  const methods = useForm({});
  const [group, setgroup] = useState([{ id: 0, val: "Select One" }]);
  const url = window.location.href;
  const pollId = url.split("/").pop();

  useEffect(() => {
    dispatch(pollResultHandler(parseInt(pollId), new Date(), setpollUsageData));
  }, [dispatch, pollId]);

  useEffect(() => {
    const arr = [{ id: 0, val: "Select One" }];
    pollUsageData?.PollGroups?.forEach((item) => {
      arr.push({
        id: item.Id,
        val: item.Name,
      });
      setgroup(arr);
    });
  }, [pollUsageData]);

  const groupChange = (e) => {
    if (e.target.value) {
      if (e.target.value === "Select One") {
        dispatch(
          pollResultHandler(parseInt(pollId), new Date(), setpollUsageData)
        );
      } else {
        const filterGroup = group.filter((item) => item.val === e.target.value);
        dispatch(
          pollResultByGroupIdHandler(
            parseInt(pollId),
            new Date(),
            parseInt(filterGroup[0]?.id),
            setpollUsageData
          )
        );
      }
    }
  };

  return (
    <BoxLayout padding={[4, 8, 4, 8]}>
      <div className={classes.pollUsage}>
        <div className={classes.pollResultMain}>
          <p className={classes.pollQuestion}><FormattedMessage id="P_QUESTION_TEXT" /></p>
          <p className={classes.pollQuestionName}>{pollUsageData?.Question}</p>
          <div className={classes.pollResult}>
            <div className={classes.pollStatusTextDiv}>
              <p className={classes.pollStatus + " " + classes.floatLeft}>
                <FormattedMessage id="P_POLL_STATUS" />
              </p>
              <p className={classes.pollStatus + " " + classes.floatRight}>
                <FormattedMessage id="P_COMPLETITION_STATUS" /> {pollUsageData.PaticipatedUsers}/
                {pollUsageData.TotalUsers}
              </p>
            </div>
            {pollUsageData?.Options?.map((data, index) => {
              return (
                <div
                  className={classes.progressPoll + " " + classes.progress}
                  key={index}
                >
                  <div
                    className={
                      classes.progressBar + " " + classes.pollProgressStriped
                    }
                    style={{ width: data.Percentage + "%" }}
                  >
                    <p className={classes.resultAns + " " + classes.floatLeft}>
                      {data.Name}
                    </p>
                  </div>
                  <p
                    className={
                      classes.resultPercentage + " " + classes.floatRight
                    }
                  >
                    {data.Percentage + "%"}
                  </p>
                  <p className={classes.votePollCount}>
                    {data.Count + " votes"}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
        <div className={classes.selectGroup}>
          <FormProvider {...methods}>
            <Input
              label={<FormattedMessage id="P_SELECT_GROUP" />}
              name="Food"
              fieldName="val"
              placeholder={intl.formatMessage({
                id: `P_SELECT_ONE`,
              })}
              defaultValue={"Select One"}
              type="select"
              labelColor="light"
              valueArr={group}
              onChange={groupChange}
            />
          </FormProvider>
        </div>
      </div>
    </BoxLayout>
  );
};

export default injectIntl(PollResult);
